"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../index");

var _withTheme = require("../../wrappers/with-theme");

var _withAuth = _interopRequireDefault(require("../../wrappers/with-auth"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeaderComponent = (0, _withAuth["default"])(function (_ref) {
  var title = _ref.title,
      _ref$LeftComponent = _ref.LeftComponent,
      LeftComponent = _ref$LeftComponent === void 0 ? null : _ref$LeftComponent,
      children = _ref.children,
      _ref$RightComponent = _ref.RightComponent,
      RightComponent = _ref$RightComponent === void 0 ? null : _ref$RightComponent,
      _ref$shadowed = _ref.shadowed,
      shadowed = _ref$shadowed === void 0 ? false : _ref$shadowed,
      user = _ref.user,
      _ref$userMenu = _ref.userMenu,
      userMenu = _ref$userMenu === void 0 ? false : _ref$userMenu,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$customTheme = _ref.customTheme,
      customTheme = _ref$customTheme === void 0 ? {} : _ref$customTheme,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? function () {} : _ref$toggle,
      open = _ref.open;

  var theme = _objectSpread(_objectSpread({}, (0, _withTheme.useTheme)()), customTheme),
      _useComponents = (0, _index.useComponents)(),
      TopUserMenu = _useComponents.TopUserMenu;

  var LeftComp = title || LeftComponent,
      RightComp = children || RightComponent;
  var tnHeight = theme.topNavHeight || _constants.DEFAULT_TOP_NAV_HEIGHT;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full relative flex items-center justify-end ".concat(theme.headerBg, " ").concat(className, " h-").concat(tnHeight),
    style: shadowed ? {
      boxShadow: "0px 6px 3px -3px rgba(0, 0, 0, 0.25)"
    } : null
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inset-0 z-0 text-3xl font-bold flex-1 items-center h-".concat(tnHeight, " flex-grow")
  }, typeof LeftComp === "function" ? /*#__PURE__*/_react["default"].createElement(LeftComp) : LeftComp), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-0 items-center relative z-10 pr-8 w-48 flex-shrink"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden xl:block"
  }, RightComp), !user || !userMenu ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-8"
  }, /*#__PURE__*/_react["default"].createElement(TopUserMenu, null)), /*#__PURE__*/_react["default"].createElement("button", {
    className: "block xl:hidden fas ".concat(open ? "fa-times" : "fa-bars", " float-right ").concat(theme.textContrast),
    onClick: toggle
  })));
});
var _default = HeaderComponent;
exports["default"] = _default;